import React from 'react';
import { Link } from 'react-router-dom';
import { useLms } from '../../context/LmsContext';
import { DataTable, PageHeader } from '../../components/ui';
import { byId } from '../../utils/lmsSelectors';

export default function QuestionBank() {
  const { data } = useLms();
  const rows = data.quizzes.flatMap((quiz) => quiz.questions.map((question) => {
    const courseVersion = byId(data.courseVersions, quiz.courseVersionId);
    const course = byId(data.courses, courseVersion?.courseId);
    return {
      id: question.id,
      courseId: course?.id,
      course: course?.title || 'Unknown course',
      quiz: quiz.title,
      type: question.questionType,
      prompt: question.prompt,
      points: question.points,
      answer: question.options.find((option) => option.isCorrect)?.optionText,
      actions: course?.id ? <Link className="button button-ghost" to={`/trainer/courses/${course.id}/builder`}>Edit in builder</Link> : '—'
    };
  }));
  return (
    <>
      <PageHeader title="Question bank" description="Reusable question-bank view. Edit existing questions from the course builder under the Quizzes tab." />
      <DataTable
        rows={rows}
        columns={[
          { key: 'course', label: 'Course' },
          { key: 'quiz', label: 'Quiz' },
          { key: 'type', label: 'Type' },
          { key: 'prompt', label: 'Prompt' },
          { key: 'points', label: 'Points' },
          { key: 'answer', label: 'Correct answer' },
          { key: 'actions', label: 'Actions' }
        ]}
        emptyMessage="No questions have been created yet."
      />
    </>
  );
}
